// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drop-overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  padding: 50px;

  background: rgba(255, 255, 255, .9);

  z-index: 1000;
}

.drop-overlay .box {
  text-align: center;
  border: dashed 4px #CCC;
  height: 100%;
  width: 100%;
  display: table;
}

.drop-overlay .label {
  font-size: 26px;
  color: #888;
  margin: auto;

  display: table-cell;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./client/css/file-drop.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;;EAER,aAAa;;EAEb,mCAAmC;;EAEnC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;;EAEZ,mBAAmB;EACnB,sBAAsB;AACxB","sourcesContent":[".drop-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n\n  padding: 50px;\n\n  background: rgba(255, 255, 255, .9);\n\n  z-index: 1000;\n}\n\n.drop-overlay .box {\n  text-align: center;\n  border: dashed 4px #CCC;\n  height: 100%;\n  width: 100%;\n  display: table;\n}\n\n.drop-overlay .label {\n  font-size: 26px;\n  color: #888;\n  margin: auto;\n\n  display: table-cell;\n  vertical-align: middle;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
